import { render, staticRenderFns } from "./cut-resistant-clothing.vue?vue&type=template&id=dcd3f692&"
import script from "./cut-resistant-clothing.vue?vue&type=script&lang=js&"
export * from "./cut-resistant-clothing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports